import { InfoOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

export default function Informacion() {
  return (
    <Box
      sx={{
        backgroundColor: "#F9FAFB",
        padding: "0.25rem 0.5rem",
      }}
    >
      <Typography
        style={{
          backgroundColor: "#fff9c4",
          color: "#f57f17",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
        variant="h4"
      >
        <InfoOutlined /> Información:
      </Typography>
      <p>Estimado/a paciente, </p>
      <p
        style={{
          fontSize: "1rem",
        }}
      >
        Le recordamos que completar este formulario de inscripción para{" "}
        <b>lista de espera no garantiza la asignación de una cita</b>. <br />
        Si se libera un horario, nos comunicaremos con usted para coordinar y
        confirmar su atención.
      </p>
    </Box>
  );
}
